import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from 'styled-components';
import { SearchInput } from '@/header/SearchInput';
import {
  MobileDrawerCloseButton,
  MobileDrawerNav,
  MobileDrawerOverlay,
} from '~/styles/mobileDrawerStyles';
import type { SidebarSection } from '../CategorySidebar';

interface CategoryDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  drawerData: SidebarSection[];
  onItemClick?: (item: string) => void;
  showSearch?: boolean;
  searchTerm?: string;
  onSearch?: (e: React.FormEvent<HTMLFormElement>) => void;
}

export function CategoryDrawer({
  isOpen,
  onClose,
  drawerData,
  onItemClick,
  showSearch = false,
  searchTerm,
  onSearch,
}: CategoryDrawerProps) {
  const handleItemClick = (item: string) => {
    onItemClick?.(item);
    onClose();
  };

  return (
    <>
      <MobileDrawerOverlay
        $breakpoint={799}
        $isOpen={isOpen}
        $zIndex={2000}
        onClick={onClose}
      />
      <MobileDrawerNav
        $isOpen={isOpen}
        $breakpoint={799}
        $padding="8px 6px"
        $width="280px"
        $zIndex={2001}
      >
        {showSearch && (
          <SearchBox>
            <SearchInput defaultValue={searchTerm} onSubmit={onSearch} />
          </SearchBox>
        )}

        <NavigationBox>
          {drawerData.map((section, index) => (
            <CategorySection key={index}>
              <SectionHeader>{section.section}</SectionHeader>
              <CategoryList>
                {section.links.map((link, linkIndex) => (
                  <LinkItem
                    key={linkIndex}
                    onClick={() => handleItemClick(link)}
                  >
                    {link}
                  </LinkItem>
                ))}
              </CategoryList>
            </CategorySection>
          ))}
        </NavigationBox>
      </MobileDrawerNav>
      <MobileDrawerCloseButton
        $breakpoint={799}
        $isOpen={isOpen}
        $zIndex={2002}
        onClick={onClose}
        // Translation Needed
        aria-label={'Close menu'}
      >
        <FontAwesomeIcon icon={faXmark} />
      </MobileDrawerCloseButton>
    </>
  );
}

const SearchBox = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  margin-bottom: 18px;
  padding: 20px 16px;

  form {
    margin: 0;
  }
`;

const NavigationBox = styled.div`
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  padding: 20px 16px;
`;

const CategorySection = styled.div`
  &:not(:last-child) {
    margin-bottom: 28px;
  }
`;

const SectionHeader = styled.h4`
  color: var(--grey-900);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.9px;
  margin: 0 0 20px 0;
  text-transform: uppercase;
`;

const CategoryList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const LinkItem = styled.li`
  cursor: pointer;
  font-size: 14px;
  letter-spacing: -0.1px;
  padding-bottom: 10px;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--wbs-red);
  }
`;
